import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faCheck, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { useSelector } from 'react-redux';
import { selectPersonalizedProjects, selectPersonalizedSyllabus } from '../../../../redux/userInfoSlice';
import { Mixpanel } from '../../../../config/Mixpanel'
import constants from '../../../../utilities/constants'


const ExpandedSyllabus = () => {
  // Logic to find the first non-removed module

  const rawSyllabusData = useSelector(selectPersonalizedSyllabus);
  const projectsData = useSelector(selectPersonalizedProjects);
  const [syllabusData, setSyllabusData] = useState([]);
  
  // Function to randomly assign action to lessons
  const randomizeActions = (syllabusData) => {
    if (!syllabusData || !syllabusData?.modules) return syllabusData;
    
    const processedSyllabus = {
      ...syllabusData,
      modules: syllabusData?.modules?.map(module => ({
        ...module,
        lessons: module?.lessons?.map(lesson => ({
          ...lesson,
          action: Math.random() < 0.5 ? 'added' : 'removed'
        })) || []
      })) || []
    };
    
    return processedSyllabus;
  };
  

  useEffect(() => {
    const processedSyllabus = randomizeActions(rawSyllabusData);
    setSyllabusData(processedSyllabus);
  }, [rawSyllabusData]);


  const findFirstNonRemovedModule = (modules) => {
    return modules?.find(module => module?.module_action !== 'removed')
  }



  // Calculate total hours based on lessons (15 minutes each)
  const calculateTotalHours = (syllabusData) => {
    const totalLessons = syllabusData?.total_lessons || 0
    const totalMinutes = totalLessons * 15
    const totalHours = Math.ceil(totalMinutes / 60) // Round up to nearest hour
    return totalHours
  }

  // Find the first non-removed module and set it as expanded by default
  const firstNonRemovedModule = findFirstNonRemovedModule(syllabusData?.modules)
  const [expandedModules, setExpandedModules] = useState(
    new Set([])
  )
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleModule = (moduleId) => {
    const newExpanded = new Set(expandedModules)
    if (newExpanded.has(moduleId)) {
      newExpanded.delete(moduleId)
    } else {
      newExpanded.add(moduleId)
    }
    setExpandedModules(newExpanded)
  }

  const toggleExpanded = () => {
    console.log('toggleExpanded')
    
    // Track syllabus expansion
    Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_SYLLABUS_EXPANDED, {
      expanded: !isExpanded
    })
    
    setIsExpanded(!isExpanded)
  }

  // Dummy industry projects data

  return (

    <div className={`w-full flex flex-col p-[1px] rounded-[24px] ${isExpanded ? 'h-full' : 'h-[405px] overflow-hidden'}`} style={{ background: "linear-gradient(to right, #406AFF 0%, #406AFF 40%, #54B226 100%)" }}>
      <div className={`w-full flex items-center justify-center rounded-[24px] ${isExpanded ? 'h-full' : 'h-[405px] overflow-hidden'}`} style={{ backgroundImage: `radial-gradient(circle, #0B305F 0%, #0A1E3F 100%)` }}>
        <div className={`relative rounded-[24px] w-full flex flex-col py-2 pb-6 px-4 ${isExpanded ? 'h-full' : 'h-[405px] overflow-hidden'}`}>
          {!isExpanded && <div className='w-full absolute bottom-0 h-[70px] z-[9999999999] -ml-4 flex items-center justify-center' style={{
            backgroundImage: `linear-gradient(
  to top,
  rgba(2, 32, 70, 1) 80%,
  rgba(2, 27, 48, 0) 100%
)`
          }}>
            <button
              onClick={toggleExpanded}
              style={{
                boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.3)",
              }}
              className="rounded-[14px] text-[#7FC241] border border-[#7FC241] bg-[#7FC241]/30 px-3 py-2  text-[14px] transition-colors flex items-center gap-1 mx-auto"
            >
              View Syllabus
              <FontAwesomeIcon icon={faArrowDown} size='sm' />
            </button>
          </div>}
          <div className="absolute inset-0 opacity-40 rounded-[24px] bg-repeat bg-[length:180px_180px]"
            style={{ backgroundImage: `url('https://assets.learntube.ai/files/personalise/web.webp')` }} />


          {/* Header */}
          <div className="w-full">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-[16px] font-semibold text-white">Course Details:</h2>
              <div className=""><img src="https://assets.learntube.ai/files/personalise/Frame%20427323080.webp" alt="" className="w-[132px] h-auto" /></div>
            </div>

            {/* Stats */}
            <div className="w-[calc(100%+28px)] ml-[-14px] pt-4" style={{
              backgroundImage: `linear-gradient(
  to right,
  rgba(64, 106, 255, 0.1) 0%,
  rgba(38, 178, 127, 0.1) 49%,
  rgba(84, 178, 38, 0) 100%
)`}} >
              <div className="flex items-center justify-around mb-6">
                <div className="text-center">
                  <div className="text-[18px] font-bold text-white leading-none mb-1">{syllabusData?.modules?.length || 0}</div>
                  <div className="text-[12px] text-[rgba(255,255,255,0.3)] font-medium">Modules</div>
                </div>
                <div className="text-center">
                  <div className="text-[18px] font-bold text-white leading-none mb-1">4</div>
                  <div className="text-[12px] text-[rgba(255,255,255,0.3)] font-medium">Real-world Projects</div>
                </div>
                <div className="text-center">
                  <div className="text-[18px] font-bold text-white leading-none mb-1">~{calculateTotalHours(syllabusData)}</div>
                  <div className="text-[12px] text-[rgba(255,255,255,0.3)] font-medium">Hours</div>
                </div>
              </div>

              {/* Curator Info */}
              <div className="flex justify-center items-center gap-3 w-full py-2" style={{ backgroundImage: "linear-gradient(to right, rgba(84,178,38,0) 0%, rgba(84,178,38,0.15) 50%, rgba(84,178,38,0) 100%)" }}>
                <img src="https://assets.learntube.ai/files/personalise/Frame%20427323060%20(1).webp" alt="" className="w-[85%] md:w-[60%] h-auto" />
              </div>
            </div>
          </div>

          {/* Scrollable Content */}
          <div className="flex-1 px-0 py-6">
            <div className="space-y-4 relative">

              {/* Vertical dotted line */}


              {syllabusData?.modules?.map((module, index) => {
                const isExpanded = expandedModules.has(module?.module_id) // Check if module is in expanded set
                const isCompleted = index === 0 // First module is completed
                const isRemoved = module?.module_action === 'removed'
                const isFirstNonRemovedModule = module?.module_id === firstNonRemovedModule?.module_id
                const isLastModule = index === (syllabusData?.modules?.length || 0) - 1

                return (
                  <div key={module?.module_id} className="relative flex items-start justify-start">

                    <div className=" mt-3 flex flex-col items-center h-full">

                      {!isLastModule && <div className={`absolute h-full -z-1 left-[11px] top-[28px] bottom-[200px] w-[2px] bg-[#021d3e] border-l-2 border-dashed ${!isRemoved ? 'border-white' : 'border-[rgba(255,255,255,0.2)]'}  `}></div>}
                      {isRemoved ?

                        <div className='w-5 h-5 -mr-1 rounded-full border-2 border-white/50 text-white/50 flex-shrink-0 flex items-center justify-center relative z-[99999]'>
                          <FontAwesomeIcon icon={faCheck} size='xs' />
                        </div>

                        :

                        isFirstNonRemovedModule ?
                          <div className='w-6 h-6 flex flex-shrink-0 items-center justify-center z-[99999]'>
                            <img alt="" src="https://assets.learntube.ai/files/personalise/Frame%20427320192.webp" className='w-6 h-6 flex-shrink-0' />
                          </div>
                          : <div className={`w-6 h-6 rounded-full border-2 border-white flex-shrink-0 flex items-center bg-[#021d3e] justify-center relative  z-[99999] font-medium text-[10px]`}>


                            {index}

                          </div>}



                      {/* <h3 className={`text-[14px] font-medium text-white ${isRemoved ? 'line-through opacity-50' : ''}`}>
                        {module.subskill}
                      </h3> */}
                    </div>


                    {/* Expanded Module Content */}

                    <div className={`w-full ml-4 ${!isRemoved ? 'pt-4 bg-[#406aff]/40' : 'bg-[#092856]/50 border border-[#70AEFF]/35 py-4'} relative z-10 rounded-[24px]`} >
                      <div className="px-4">
                        <h3 className={`text-[14px] font-semibold  leading-[130%] ${isRemoved ? 'line-through opacity-50  text-white' : 'text-[#83BEFF]'}`}>
                          {module?.subskill}
                        </h3>
                        {module?.module_justification && <p className="text-[10px] text-[rgba(255,255,255,0.5)] mt-1 italic font-normal leading-[130%]">
                          {module?.module_justification}
                        </p>}
                      </div>
                      {!isRemoved && <div className=" rounded-[24px] px-4 py-4 mt-1" style={{
                        backgroundImage: ` linear-gradient(
  to bottom,
  rgba(1, 23, 40, 1) 0%,
  rgba(0, 0, 0, 0.25) 100%
)`}}>
                        {/* Module Header */}
                        {<div className="flex items-center justify-between cursor-pointer" onClick={() => toggleModule(module?.module_id)}>
                          <div className="flex items-center gap-2">
                            <div className="text-[9px] flex justify-start items-center gap-1">
                              <img width={12} height={12} src="https://assets.learntube.ai/files/personalise/Group%2023634.webp" alt="" />
                              <span className="text-[#54B226] font-normal">+{module?.lessons?.filter(l => l?.action === 'added')?.length || 0} added </span> <div className="w-1 h-1 rounded-full bg-white/30" /> <span className="text-[#EF9121]  font-normal flex justify-center items-center gap-1">-{module?.lessons?.filter(l => l?.action === 'removed')?.length || 0} skipped</span>
                            </div>
                          </div>
                          <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} className="w-[8px] h-auto text-[#406AFF]" />
                        </div>}



                        {/* Lessons */}
                        {isExpanded && <div className="mt-3 space-y-3">
                          {module?.lessons?.map((lesson, lessonIndex) => {
                            const getLessonIcon = () => {
                              if (lesson?.action === 'added') return <span className="text-[#54b226] text-[12px] font-bold mt-0.5">+</span>
                              if (lesson?.action === 'removed') return <span className="text-[#e06064] text-[12px] font-bold mt-0.5">-</span>
                              return <span className="text-[#406AFF] text-[12px] mt-0">•</span>
                            }

                            const getLessonDescription = () => {
                              if (lesson?.action === 'added' && lesson?.justification) {
                                return lesson?.justification
                              }
                              if (lesson?.action === 'removed' && lesson?.justification) {
                                return lesson?.justification
                              }
                              return null
                            }

                            return (
                              <div key={lesson?.lesson_id} className="flex items-start gap-2">
                                {getLessonIcon()}
                                <div className="flex-1">
                                  <div className={`text-white text-[12px] font-medium mb-1`}>
                                    {lesson?.title}
                                  </div>
                                  {getLessonDescription() && (
                                    <div className="text-[rgba(255,255,255,0.8)] text-[10px] flex items-center gap-1">
                                      {lesson?.action === 'added' && <img src="https://assets.learntube.ai/files/personalise/ix_work-case-filled.webp" width={12} height={12} alt=""></img>}
                                      {lesson?.action === 'removed' && <img src="https://assets.learntube.ai/files/personalise/ix_work-case-filled%20(1).webp" width={12} height={12} alt=""></img>}
                                      <span className="text-[10px] italic leading-[130%] text-[#70AEFF]/50">{getLessonDescription()}</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )
                          })}
                        </div>}
                      </div>}
                    </div>



                  </div>
                )
              }) || []}
            </div>

            {/* Industry Projects Section */}
            {projectsData?.length > 0 && <div className="w-full mt-8 px-0 overflow-hidden">
              <h3 className="text-[16px] font-bold text-white mb-4">Industry Recognised Projects</h3>
              <Swiper
                spaceBetween={12}
                slidesPerView={1.2}
                breakpoints={{
                  480: {
                    slidesPerView: 1.5,
                  },
                  640: {
                    slidesPerView: 2.4,
                  }
                }}
                className="!overflow-visible swiper-equal-height"
              >
                {projectsData?.map((project , index) => (
                  <SwiperSlide key={index} className="h-auto">
                    <div className="bg-[rgba(64,106,255,0.1)] flex flex-col gap-4 items-start px-4 py-3 rounded-[12px] w-[250px] h-full min-h-[120px]">
                      <div className="h-6 relative shrink-0 w-[26px]">
                        <img alt="" className="block max-w-none size-full" src={'https://assets.learntube.ai/files/personalise/Vector%20(17).webp'} />
                      </div>
                      <div className="flex flex-col items-start w-full flex-1">
                        <p className="font-normal leading-[1.4] text-[12px] text-white w-full">
                          {project?.slice(3)}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                )) || []}
              </Swiper>
            </div>}
          </div>

          {/* Footer */}
          <div className='w-full  z-[9999999999] items-center justify-center'>
            <button
              onClick={toggleExpanded}
              className="rounded-[12px] text-[#7FC241] border border-[#7FC241] bg-[#7FC241]/30 px-2 py-2  text-[12px] transition-colors flex items-center gap-1 mx-auto"
            >
              Hide
              <FontAwesomeIcon icon={faArrowUp} size='xs' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExpandedSyllabus